import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { RestService } from '../rest.service';

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.css']
})
export class PaymentConfirmationComponent implements OnInit {

  constructor(private _restService: RestService, private route: ActivatedRoute, private router: Router) {}

  isLoading = false;

  failure = false;
  success = false;

  failureMsg: string;
  successMsg: string;

  redirectUrl: string;

  ngOnInit() {
    const token = this.route.snapshot.paramMap.get("token");

    if (token) {
      this.isLoading = true;
      this._restService
      .verifyPayment(decodeURIComponent(token))
      .pipe(
        catchError((e) => {
          this.isLoading = false;
          this.failure = true;
          this.failureMsg = e && e.error && e.error.StatusInfo;
          return e;
        })
      )
      .subscribe((f: any) => {
        this.isLoading = false;
        this.success = true;
        this.successMsg = f.StatusInfo;
      });
    }
  }

  redirect() {
    this.redirectUrl = decodeURIComponent(this.route.snapshot.paramMap.get("redirect"));
    console.log(this.redirectUrl);
    this.router.navigate([this.redirectUrl]);
  }

}
